import { api } from './api';

export interface WhiteLabelCreditInfo {
    maxCredits: number;
    usedCredits: number;
    availableCredits: number;
}

export const whiteLabelApi = {
    async getCreditInfo(): Promise<WhiteLabelCreditInfo> {
        return api.get<WhiteLabelCreditInfo>('/WhiteLabel/GetCreditInfo', { auth: true });
    },
};
